export default "__VITE_ASSET__025ed9cf__"